import { render, staticRenderFns } from "./AmountSelector.vue?vue&type=template&id=0c8efc6f&"
import script from "./AmountSelector.vue?vue&type=script&lang=js&"
export * from "./AmountSelector.vue?vue&type=script&lang=js&"
import style0 from "./AmountSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports